import { Lock } from "lucide-react";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { fieldLabel } from "../lib/fieldMeta";

const PLACEHOLDERS = { tel: "+966 5x xxx xxxx", url: "username or link", ext: "123", email: "name@example.com" };

export const ProfileFieldInput = ({ field, value, onChange, readOnly, lang, testPrefix }) => {
  const id = `${testPrefix}-${field.key}`;
  const rtl = field.dir === "rtl";
  const mobile = field.key === "phone" || field.key === "whatsapp";
  const common = {
    id, dir: field.dir, value: value || "", readOnly, disabled: readOnly, "data-testid": id,
    placeholder: mobile ? "05xxxxxxxx" : PLACEHOLDERS[field.type] || "",
    onChange: (e) => onChange(field.key, mobile ? e.target.value.replace(/\D/g, "").slice(0, 10) : e.target.value),
    ...(mobile && { inputMode: "numeric", maxLength: 10, pattern: "0[0-9]{9}", title: "10 digits starting with 0" }),
    className: `rounded-xl text-sm ${rtl ? "font-arabic text-right" : "text-start"} ${field.type === "tel" || field.type === "url" || field.type === "ext" ? "font-mono" : ""}`,
  };
  return (
    <div className={`space-y-1.5 ${field.type === "textarea" ? "sm:col-span-2" : ""}`}>
      <Label htmlFor={id} className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-slate-500">
        {fieldLabel(field, lang)}
        {field.required && <span className="text-wade" data-testid={`${id}-required`}>*</span>}
        {readOnly && <Lock className="h-3 w-3" />}
      </Label>
      {field.type === "textarea"
        ? <Textarea rows={3} {...common} />
        : <Input type={field.type === "tel" || field.type === "email" ? field.type : "text"} {...common} className={`h-12 ${common.className}`} />}
    </div>
  );
};
